import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface TrainingResource {
  id: string;
  title: string;
  description: string | null;
  file_url: string | null;
  embed_code: string | null;
  resource_type: string;
  is_active: boolean;
}

interface UseLocationTrainingVideoReturn {
  video: TrainingResource | null;
  loading: boolean;
  hasVideo: boolean;
  displayTitle: string | null;
}

export const useLocationTrainingVideo = (locationKey: string): UseLocationTrainingVideoReturn => {
  const [video, setVideo] = useState<TrainingResource | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrainingVideo = async () => {
      if (!locationKey) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('training_resources')
          .select('*')
          .eq('title', locationKey)
          .eq('is_active', true)
          .maybeSingle();

        if (error && error.code !== 'PGRST116') {
          console.error('Error fetching training resource:', error);
          return;
        }

        setVideo(data);
      } catch (error) {
        console.error('Error fetching training resource:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingVideo();
  }, [locationKey]);

  // Parse display title from description JSON
  const getDisplayTitle = (): string | null => {
    if (!video?.description) return null;
    
    try {
      const parsed = JSON.parse(video.description);
      return parsed.displayTitle || null;
    } catch (e) {
      return null;
    }
  };

  return {
    video,
    loading,
    hasVideo: !!video,
    displayTitle: getDisplayTitle()
  };
};